import React from "react";
import { AlarmTypeChip as StyledAlarmTypeChip } from "styles/components/deviceAlarms.styles";

interface AlarmTypeChipProps {
  type: string;
}

const AlarmTypeChip: React.FC<AlarmTypeChipProps> = ({ type }) => {
  return <StyledAlarmTypeChip type={type}>{type}</StyledAlarmTypeChip>;
};

export default AlarmTypeChip;
